import CONTANTS from "../constants";
import fields from "../fields";

var ExportLineItemValues = {
    [CONTANTS.TRANSACTIONID.MASTERS.EQUIPMENT_CATEGORY]:[
        {
            header: "Equipment Category Code ",
            field: "categoryCode"
        },
        {
            header:"Equipment Category Name",
            field: "categoryName"
        },
        {
            header: " Active",
            field: "isActiveStatue"
        },
        {
            header: "Remarks",
            field: "remarks"
        }
    ],

    [CONTANTS.TRANSACTIONID.MASTERS.VENDOR]: [
        {
            header: "Vendor Code",
            field: "vendorCode", // 0
        },
        {
            header: "Vendor Name",
            field: "vendorName", // 1
        },
        {
            header: "Payment_Terms",
            field: "creditTermCode", // 2
        },
        {
            header: "Remarks",
            field: "remarks", // 3
        },
        {
            header: "Active",
            field: "isActiveStatue", // 4
        },
        {
            header: "CreateBy",
            field: "createBy", // 5
        },
        {
            header: "Create Date",
            field: "oldCreateDate", // 6
        },
        {
            header: "EditBy",
            field: "editBy", // 7
        },
        {
            header: "EditDate",
            field: "oldEditDate", // 8 
        },
    ],
    [CONTANTS.TRANSACTIONID.MASTERS.IMPACODE]:[
        {
            header: "IMPA Code",
            field: "iMPACode", // 0
        },
        {
            header: "Description",
            field: "iMPACategoryDescription", // 1
        },
        {
            header: "Category",
            field: "iMPACategoryCode", // 2
        },
        {
            header: "UOM",
            field: "uomCode", // 3
        },
        {
            header: "Active",
            field: "isActiveStatue", // 4
        },
        {
            header: "Create By",
            field: "createBy", // 5
        },
        {
            header: "Created Date",
            field: "newCreateDate", // 6
        },
    ],
    [CONTANTS.TRANSACTIONID.MASTERS.IMPACATEGORY]:[
        {
            header: "Category Code",
            field: "iMPACategoryCode", // 0
        },
        {
            header: "Category Name",
            field: "iMPACategoryName", // 1
        },
        {
            header: "mainCode",
            field: "GL Code", // 2
        },
        {
            header: "Active",
            field: "isActiveStatue", // 3
        },
        {
            header: "Create By",
            field: "createBy", // 4
        },
        {
            header: "Created Date",
            field: "newCreateDate", // 5
        },
        ],
    [CONTANTS.TRANSACTIONID.MASTERS.CONTRACTCATEGORY]:[
        {
            header: "Category Code",
            field: "contractCategoryCode", // 0
        },
        {
            header: "Category Name",
            field: "contractCategoryName", // 1
        },
        {
            header: "GL Code",
            field: "mainCode", // 2
        },
        {
            header: "Active",
            field: "isActiveStatue", // 3
        },
        {
            header: "Create By",
            field: "createBy", // 4
        },
        {
            header: "Created Date",
            field: "newCreateDate", // 5
        },
    ],
    [CONTANTS.TRANSACTIONID.MASTERS.CREDITTERM]:[
        {
            header: "Credit Term Code",
            field: "creditTermCode", // 0
        },
        {
            header: "Credit Term Name",
            field: "creditTermName", // 1
        },
        {
            header: "No Of Days",
            field: "noOfDays", // 2
        },
        
        {
            header: "Active",
            field: "isActiveStatue", // 3
        },
        {
            header: "Create By",
            field: "createBy", // 4
        },
        {
            header: "Created Date",
            field: "newCreateDate", // 5
        },
        {
            header: "Remarks",
            field: "remarks", // 5
        },
    ],
    [CONTANTS.TRANSACTIONID.MASTERS.EMPLOYEECATEGORY]:[
        {
            header: "Category Code",
            field: "categoryCode", // 0
        },
        {
            header: "Category Name",
            field: "categoryName", // 1
        },
        {
            header: "Active",
            field: "isActiveStatue", // 2
        },
        {
            header: "Create By",
            field: "createBy", // 3
        },
        {
            header: "Created Date",
            field: "newCreateDate", // 4
        },
    ],
    [CONTANTS.TRANSACTIONID.MASTERS.REASON_FOR_REWARD]:[
        {
            header: "Reward Code",
            field: "rewardCode", // 0
        },
        {
            header: "Description",
            field: "rewardDescription", // 1
        },
        
        {
            header: "Create By",
            field: "createBy", // 2
        },
        {
            header: "Created Date",
            field: "newCreateDate", // 3
        },
        {
            header: "Edit By",
            field: "editBy", // 4
        },
        {
            header: "Edit Date",
            field: "neweditDate", // 5
        },
        {
            header: "Active",
            field: "isActiveStatue", // 6
        },        
    ],
    [CONTANTS.TRANSACTIONID.MASTERS.MAINCODE]:[
        {
            header: "GL Code",
            field: "mainCode", // 0
        },
        {
            header: "GL Code Desc",
            field: "mainCodeDescription", // 1
        },
        {
            header: "Remarks",
            field: "remarks", // 2
        },
        
        {
            header: "Active",
            field: "isActiveStatue", // 3
        },
        {
            header: "Create By",
            field: "createBy", // 4
        },
        {
            header: "Created Date",
            field: "newCreateDate", // 5
        },
    ],
    [CONTANTS.TRANSACTIONID.MASTERS.VESSEL]:[
        {
            header: "Vessel Code",
            field: "bargeCode", // 0
        },
        {
            header: "Vessel Name",
            field: "bargeName", // 1
        },
        {
            header: "Vessel Suffix",
            field: "vesselSuffix", // 2
        },
        
        {
            header: "Call Sign",
            field: "callSign", // 3
        },
        {
            header: "Licence NO",
            field: "licenseNo", // 4
        },
        {
            header: "Active",
            field: "isActiveStatue", // 5
        },
        {
            header: "Create By",
            field: "createBy", // 6
        },
        {
            header: "Created Date",
            field: "newCreateDate", // 7
        },
    ],
    [CONTANTS.TRANSACTIONID.MASTERS.EMPLOYEE]:[
        {
            header: "Employee Code",
            field: "employeeCode", // 0
        },
        {
            header: "Employee Name",
            field: "employeeName", // 1
        },
        
        {
            header: "Active",
            field: "isActiveStatue", // 2
        },
        {
            header: "Create By",
            field: "createBy", // 3
        },
        {
            header: "Created Date",
            field: "newCreateDate", // 4
        },
    ],
    [CONTANTS.TRANSACTIONID.MASTERS.UOM]:[
        {
            header: "UOM Code",
            field: "uomCode", // 0
        },
        {
            header: "UOM Name",
            field: "uomName", // 1
        },
        {
            header: "Active",
            field: "isActiveStatue", // 2
        },
        {
            header: "Create By",
            field: "createBy", // 3
        },
        {
            header: "Created Date",
            field: "newCreateDate", // 4
        },
    ],
    [CONTANTS.TRANSACTIONID.MASTERS.VESSELDEPARTMENT]:[
        {
            header: "Vessel Department Code",
            field: "vesselDepartmentCode", // 0
        },
        {
            header: "Vessel Department Name",
            field: "vesselDepartmentName", // 1
        },
        {
            header: "Remarks",
            field: "remarks", // 2
        },
        {
            header: "Active",
            field: "isActiveStatue", // 3
        },
        {
            header: "Create By",
            field: "createBy", // 4
        },
        {
            header: "Created Date",
            field: "newCreateDate", // 5
        },
    ],
    [CONTANTS.TRANSACTIONID.MASTERS.PORT]:[
        {
            header: "Port Code",
            field: "portCode", // 0
        },
        {
            header: "Port Name",
            field: "portName", // 1
        },
        {
            header: "Remarks",
            field: "remarks", // 2
        },
        {
            header: "Active",
            field: "isActiveStatue", // 3
        },
        {
            header: "Create By",
            field: "createBy", // 4
        },
        {
            header: "Created Date",
            field: "newCreateDate", // 5
        },
    ],
    [CONTANTS.TRANSACTIONID.MASTERS.GST]:[
        {
            header: "GST Code",
            field: "gstCode", // 0
        },
        {
            header: "GST Name",
            field: "gstName", // 1
        },
        {
            header: "GST Percentage",
            field: "gSTPercentage", // 2
        },
        {
            header: "Active",
            field: "isActiveStatue", // 3
        },
        {
            header: "Create By",
            field: "createBy", // 4
        },
        {
            header: "Created Date",
            field: "newCreateDate", // 5
        },
    ],

    EquipmentMasterExcelItems:[
        {
            header: "Equipment Category Name",
            field: "categoryName",
        },
        {
            header: "EquipmentCode",
            field: "equipmentCode", // 0
        },
        {
            header: "EquipmentName",
            field: "equipmentName", // 1
        },
        {
            header: "Active",
            field: "isActiveStatus", // 2
        },
        {
            header: "Remarks",
            field: "remarks", // 3
        },
        {
            header: "Active",
            field: "isActiveStatue", // 4
        },
        {
            header: "Create By",
            field: "createBy", // 5
        },
        {
            header: "Created Date",
            field: "newCreateDate", // 6
        },
    ],
    
    ModelMasterExcelItems: [
        {
            header: "Model",
            field: "modelType", // 0
        },
        {
            header: "SerialNo",
            field: "serialNo", // 1
        },
        // {
        //     header: "Model",
        //     field: "modelType", // 
        // },
        {
            header: "Make",
            field: "make", // 2
        },
        {
            header: "Active",
            field: "isActiveStatus", // 3
        },
        {
            header:"Year of Manufacter",
            field:"yearManufactured",
        },
        {
            header: "Remarks",
            field: "remarks", // 4
        },
    ],

    [CONTANTS.TRANSACTIONID.MASTERS.SPAREPARTS]: [
        {
            header: "Equipment Name",
            field: "equipmentName", // 0
        },
        {
            header: "Model Type",
            field: "modelType", // 1
        },
        {
            header: "Part No",
            field: "partNo", // 2
        },
        {
            header: "Part Name",
            field: "partName", // 3
        },
        {
            header: "UOM",
            field: "uomCode", // 4
        },
        {
            header: "Active",
            field: "isActiveStatue", // 5
        },
        {
            header: "Remarks",
            field: "remarks", // 6
        },
    ]

}

export default ExportLineItemValues;